const { sanitiseBatchNo } = require('../../../batch/tools')
const { SHIPSY_SOURCE, STOCK_TRANSACTION_TYPES } = require('../../constants')

// Adjustment payload:
//   { request_id, inventory_adjustment_data: [
//       { warehouse, zone, sku_code, batch_number, adjusted_quantity,
//         updated_quantity, previous_quantity, reason_code,
//         adjusted_by, adjusted_at }
//     ] }
//
// Direction is single-sided: a removal (delta < 0) populates origin;
// an addition (delta > 0) populates destination. Quantity is unsigned magnitude.
//
// Top-level shape guards return [] on malformed payloads (missing or empty
// inventory_adjustment_data) so the domain handler owns the 400 response.
async function extract (payload, { mainApi }) {
  const items = payload && payload.inventory_adjustment_data
  if (!Array.isArray(items) || items.length === 0) return []

  const requestId = String(payload.request_id)
  const isBulkUpload = items[0].reason_code === 'Bulk Upload'
  const rows = []

  for (const item of items) {
    if (!item.warehouse) continue

    const location = await mainApi.location.pgAdapter.getOneByCode(item.warehouse)
    const delta = isBulkUpload
      ? Number(item.updated_quantity) - Number(item.previous_quantity)
      : Number(item.adjusted_quantity)

    if (delta === 0) continue

    const isRemoval = delta < 0
    const magnitude = Math.abs(delta)

    rows.push({
      source: SHIPSY_SOURCE,
      type: STOCK_TRANSACTION_TYPES.ADJUSTMENT,
      request_id: requestId,
      origin: isRemoval ? location.fsid : null,
      origin_zone: isRemoval ? (item.zone || null) : null,
      destination: isRemoval ? null : location.fsid,
      destination_zone: isRemoval ? null : (item.zone || null),
      sku: String(item.sku_code),
      batch: sanitiseBatchNo(item.batch_number || 'UNKNOWN'),
      quantity: magnitude,
      reason: item.reason_code,
      payload: item,
      created_at: item.adjusted_at,
      created_by: item.adjusted_by,
      updated_at: item.adjusted_at,
      updated_by: item.adjusted_by
    })
  }

  return rows
}

module.exports = extract
